import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Organization from './view/organization';

const OrganizationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Organization />} />
    {/* <Route path="new" element={<DepartmentUpdate />} />
    <Route path=":id">
      <Route index element={<DepartmentUpdate />} />
    </Route> */}
  </ErrorBoundaryRoutes>
);

export default OrganizationRoutes;
